export class ColumnsWidthClasses {
  constructor() {
    this.initAvailableWidths()
    this.initDefaultWidths()
  }

  initAvailableWidths() {
    this.availableWidths = {
      'WIDTH_1_12': {
        classes: {
          phone: [
            {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
          ],
          tablet: [
            {property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false}
          ],
          desktop: [
            {property: 'ColumnWidth', value: 'WIDTH_1_12', touched: false}
          ]
        },
        maxPercentageSize: .083
      },
      'WIDTH_2_12': {
        classes: {
          phone: [
            {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
          ],
          tablet: [
            {property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false}
          ],
          desktop: [
            {property: 'ColumnWidth', value: 'WIDTH_2_12', touched: false}
          ]
        },
        maxPercentageSize: .167
      },
      'WIDTH_3_12': {
        classes: {
          phone: [
            {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
          ],
          tablet: [
            {property: 'ColumnWidth', value: 'WIDTH_6_12', touched: false}
          ],
          desktop: [
            {property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false}
          ]
        },
        maxPercentageSize: .25
      },
      'WIDTH_4_12': {
        classes: {
          phone: [
            {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
          ],
          tablet: [
            {property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false}
          ],
          desktop: [
            {property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false}
          ]
        },
        maxPercentageSize: .333
      },
      'WIDTH_6_12': {
        classes: {
          phone: [
            {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
          ],
          tablet: [
            {property: 'ColumnWidth', value: 'WIDTH_6_12', touched: false}
          ],
          desktop: [
            {property: 'ColumnWidth', value: 'WIDTH_6_12', touched: false}
          ]
        },
        maxPercentageSize: .5
      },
      'WIDTH_12_12': {
        classes: {
          phone: [
            {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
          ],
          tablet: [
            {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
          ],
          desktop: [
            {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
          ]
        },
        maxPercentageSize: 1
      }
    }
  }
  
  initDefaultWidths() {
    this.defaultWidths = [
      {columns: 1, width: 'WIDTH_12_12'},
      {columns: 2, width: 'WIDTH_6_12'},
      {columns: 3, width: 'WIDTH_4_12'},
      {columns: 4, width: 'WIDTH_3_12'},
      {columns: 5, width: 'WIDTH_2_12'},
      {columns: 6, width: 'WIDTH_2_12'},
      {columns: 7, width: 'WIDTH_1_12'},
      {columns: 8, width: 'WIDTH_1_12'},
      {columns: 9, width: 'WIDTH_1_12'},
      {columns: 10, width: 'WIDTH_1_12'},
      {columns: 11, width: 'WIDTH_1_12'},
      {columns: 12, width: 'WIDTH_1_12'},
    ]
  }

  widthForColumns(columnsQuantity) {
    let width = this.defaultWidths.find(defaultWidth => defaultWidth.columns == columnsQuantity).width
    return this.availableWidths[width].classes
  }
}